// extracted by mini-css-extract-plugin
module.exports = {"label":"_9eb0de5","content":"_5a75cd5","marginTop":"_08c5fa8"};